import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/app/global-error.js");
